module.exports = __webpack_public_path__ + "img/icon-account-profile.8083b784.jpg";